import logo from './logo.svg';

export const settings = {
    "title": "MP EDILE",
    "apiUrl": "https://api-app.mpedileimmobiliare.it/api",
    "storageUrl": "https://api-app.mpedileimmobiliare.it/",
    "tinyKey": "u2y9r6cw0e1erg33drzg4fs0swwi1zrs85bcin3ynrsxlwz2",
    "googleMapKey": "inserire_chiave_valida",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "locale": {
        "currency": 'EUR',
        "country": 'it-IT'
    },
    "logo": logo,
    "modalDefaultSize": {
        delete: 'md',
        details: 'xl',
        entityCompiler: 'xl',
        entityConfig: 'lg',
        entityExport: 'md',
        entityImport: 'xl',
        entityViewer: 'xl',
        list: 'xl',
        listPicker: 'xl',
        picker: 'xl',
        viewFile: 'xl'
    },
    "modalFullscreen": {
        list: false,
        listPicker: false,
        picker: false
    },
    "debug": false,
    "advancedAnalytics": [0],
    "usingCache": false
}